// Solo queue helpers (plain functions so they can be checked without a React test setup).

// Server status to request for each tab. Each tab asks the server for its own status, so the newest
// approved or rejected rows cannot push pending ones out of the page.
const FILTER_QUERY_STATUS = {
  All:       'all',
  Submitted: 'pending_verification',
  Pending:   'pending',
  Approved:  'approved',
  Rejected:  'rejected',
};

export const soloQueueStatus = (filter) => FILTER_QUERY_STATUS[filter] || 'all';

// The reject route reports whether the rejection email was accepted for delivery.
export const soloRejectToast = (emailSent) => (emailSent === true
  ? 'Application rejected. The healer was notified.'
  : 'Application rejected. No email could be sent, please inform the healer.');

// A response (or its cleanup) is applied only if it belongs to the newest request; an older one is dropped.
export const isLatestRequest = (seq, latestSeq) => seq === latestSeq;

// Only a real tab name selects a tab. Anything else (for example the click event a Retry button passes
// when wired directly) falls back to the active tab instead of silently asking for status=all.
export const resolveSoloFilter = (arg, activeFilter) => (
  typeof arg === 'string' && Object.prototype.hasOwnProperty.call(FILTER_QUERY_STATUS, arg) ? arg : activeFilter
);
